import Entity, { GameEvents } from "../../core/entity/Entity";
import { choose } from "../../core/util/Random";
import Asteroid from "../asteroids/Asteroid";
import { AsteroidSize } from "../asteroids/AsteroidShapes";
import { LevelEntity } from "../LevelEntity";
import { BasicBomb } from "../munitions/BasicBomb";
import { BigBomb } from "../munitions/BigBomb";
import { Missile } from "../munitions/Missile";

/**
 * Debug/testing utilities for levels.
 * Provides cheat key bindings for spawning entities and testing features.
 */
export default class LevelCheats extends LevelEntity implements Entity {
  pausable = false; // Work even when paused for debugging

  onKeyDown({ key }: GameEvents["keyDown"]) {
    if (!this.game) return;

    switch (key) {
      case "KeyA":
        // Spawn asteroid at cursor
        this.getCurrentLevel()?.addChild(
          new Asteroid(
            this.game.camera.toWorld(this.game.io.mousePosition),
            AsteroidSize.MEDIUM,
          ),
        );
        break;
      case "KeyM":
        // Spawn random munition at cursor
        const cursorWorldPos = this.game.camera.toWorld(
          this.game.io.mousePosition,
        );
        const randomChoice = choose(0, 1, 2);
        let munition;
        switch (randomChoice) {
          case 0:
            munition = new BasicBomb(cursorWorldPos);
            break;
          case 1:
            munition = new BigBomb(cursorWorldPos);
            break;
          case 2:
            munition = new Missile(cursorWorldPos);
            break;
          default:
            munition = new BasicBomb(cursorWorldPos);
        }
        this.getCurrentLevel()?.addChild(munition);
        break;
      case "KeyL":
        // Auto-win current level
        this.dispatch("levelComplete", {
          level: this.getGameFlowManager()?.currentLevel || 1,
          enemiesKilled: 0,
        });
        break;
      default:
        break;
    }
  }
}
